import {takeLatest} from 'redux-saga/effects';
import * as saga from './saga';
import * as ACTION from './constants';

export default function*() {
    yield takeLatest(ACTION.CREATE_PACKAGE_SAME_BARCODE.REQUEST, saga.createPackageSameBarcode);
    yield takeLatest(ACTION.CREATE_PACKAGE_SAME_BARCODE.SUCCESS, saga.onCreatePackageSameBarcodeSuccess);
    yield takeLatest(ACTION.CREATE_PACKAGE_SAME_BARCODE.FAILED, saga.onCreatePackageSameBarcodeFailed);
}
